import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { cta, BRAND } from "@/lib/site";

export const Footer = () => {
  return (
    <footer
      className="relative bg-[#2B3A55] text-[#F7F5F0] pt-24 md:pt-32 pb-10 overflow-hidden"
      data-testid="site-footer"
    >
      <div className="absolute inset-0 paper-grain opacity-60 pointer-events-none" />
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 relative">
        <div className="grid grid-cols-12 gap-6 mb-20">
          <div className="col-span-12 md:col-span-7">
            <motion.h3
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
              className="font-serif-display italic text-[#F7F5F0] text-4xl md:text-5xl leading-[1.05] max-w-xl"
            >
              PS — the best marketing feels like a note from a friend.
            </motion.h3>
          </div>
          <div className="col-span-12 md:col-span-5 flex md:justify-end items-end">
            <a
              href={cta("footer-cta")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-cta"
              className="group inline-flex items-center gap-3 bg-[#F7F5F0] text-[#1C1C1A] px-8 py-4 rounded-full text-sm uppercase tracking-[0.22em] font-semibold hover:bg-[#D93829] hover:text-white transition-colors duration-500"
            >
              Open Thanks.io
              <ArrowUpRight
                size={16}
                className="transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1"
              />
            </a>
          </div>
        </div>

        {/* Huge wordmark */}
        <div className="border-t border-[#F7F5F0]/20 pt-10 mb-14">
          <div className="font-serif-display italic text-[#F7F5F0] text-[22vw] md:text-[18vw] leading-[0.85] tracking-tighter select-none">
            {BRAND.wordmark}
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6 text-[13px] text-[#F7F5F0]/70">
          <div className="col-span-12 md:col-span-4">
            <div className="uppercase tracking-[0.2em] text-[#F7F5F0] text-xs mb-3">
              Return Address
            </div>
            <p className="leading-relaxed">
              {BRAND.wordmark} is an independent editorial site celebrating
              direct mail as a marketing channel.
            </p>
          </div>
          <div className="col-span-6 md:col-span-4">
            <div className="uppercase tracking-[0.2em] text-[#F7F5F0] text-xs mb-3">
              Send Something
            </div>
            <ul className="space-y-2">
              <li>
                <a
                  href={cta("footer-link")}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-underline hover:text-white"
                  data-testid="footer-link-thanksio"
                >
                  Thanks.io
                </a>
              </li>
              <li>
                <a
                  href="/#manifesto"
                  className="link-underline hover:text-white"
                  data-testid="footer-link-manifesto"
                >
                  The Manifesto
                </a>
              </li>
              <li>
                <a
                  href="/#faq"
                  className="link-underline hover:text-white"
                  data-testid="footer-link-faq"
                >
                  FAQ
                </a>
              </li>
              <li>
                <a
                  href="/#gallery"
                  className="link-underline hover:text-white"
                  data-testid="footer-link-gallery"
                >
                  The Cards
                </a>
              </li>
              <li>
                <a
                  href="/#guide"
                  className="link-underline hover:text-white"
                  data-testid="footer-link-guide"
                >
                  Field Guide
                </a>
              </li>
            </ul>
          </div>
          <div className="col-span-6 md:col-span-4">
            <div className="uppercase tracking-[0.2em] text-[#F7F5F0] text-xs mb-3">
              Postmark &amp; Co.
            </div>
            <ul className="space-y-2">
              <li>
                <a href="/about" className="link-underline hover:text-white" data-testid="footer-link-about">
                  About
                </a>
              </li>
              <li>
                <a href="/contact" className="link-underline hover:text-white" data-testid="footer-link-contact">
                  Contact
                </a>
              </li>
              <li>
                <a href="/privacy" className="link-underline hover:text-white" data-testid="footer-link-privacy">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/terms" className="link-underline hover:text-white" data-testid="footer-link-terms">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#F7F5F0]/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[11px] uppercase tracking-[0.24em] text-[#F7F5F0]/50">
          <div>© {new Date().getFullYear()} {BRAND.wordmark}. Postage due, always.</div>
          <div className="max-w-xl">
            Affiliate disclosure: links on this site route through our Thanks.io
            partner code (ahx). We may earn a commission at no cost to you.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
